import React from 'react';
import { Button } from '../../ui/Button';
import { Calendar } from 'lucide-react';
import { toast } from 'sonner';
import { apiGet } from '../../../api/client';

export function CalendarStep() {
  const [connecting, setConnecting] = React.useState(false);

  const handleConnect = async () => {
    setConnecting(true);
    try {
      const { url } = await apiGet<{ url: string }>('/calendar/auth-url-with-state');
      window.open(url, '_blank');
      toast.success("Completa l'autenticazione Google nella nuova finestra");
    } catch {
      toast.error('Errore nel recupero URL di autenticazione');
    } finally {
      setConnecting(false);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      <p style={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-muted)' }}>
        Connetti Google Calendar per sincronizzare automaticamente gli eventi.
      </p>
      <Button onClick={handleConnect} loading={connecting} icon={<Calendar size={14} />} style={{ alignSelf: 'flex-start' }}>
        Connetti Google Calendar
      </Button>
      <p style={{ fontSize: 'var(--text-xs)', color: 'var(--color-text-faint)' }}>
        Potrai configurare il calendario anche dopo da Impostazioni → Calendario.
      </p>
    </div>
  );
}
